export default [
  // 极速抢答
  {
    path: '/BattleCenter',
    name: 'BattleCenter',
    meta: {
      IndexHeader: true,
      itemIndex: -1
    },
    component: () =>
      import(/* webpackChunkName: "BloomLive" */ '@/components/combatSystem/index')
  },
  {
    path: '/BattleList',
    name: 'BattleList',
    // meta: {
    //   // IndexHeader: true,
    //   itemIndex: 0
    // },
    component: () =>
      import(/* webpackChunkName: "BloomLive" */ '@/components/combatSystem/battleList')
  },
  {
    path: '/BattleRoom',
    name: 'BattleRoom',
    // meta: {
    //   // IndexHeader: true,
    //   itemIndex: 0
    // },
    component: () =>
      import(/* webpackChunkName: "BloomLive" */ '@/components/combatSystem/battleRoom')
  },
  {
    path: '/BattleResult',
    name: 'BattleResult',
    // meta: {
    //   // IndexHeader: true,
    //   itemIndex: 0
    // },
    component: () =>
      import(/* webpackChunkName: "BloomLive" */ '@/components/combatSystem/battleResult')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/battleCenter.js